
import './App.css';

function Main() {
    return (
        <div id={"main"} className="flex flex-col justify-center items-center h-[100vh]">
          <h1 className={"name_header text-6xl font-nunito font-avenir font-helvetica font-sans text-black text-opacity-70"}> Netanel Arbiv</h1>
            <h3 className={"job_header text-3xl font-nunito font-avenir font-helvetica font-sans text-black text-opacity-70"}> Full-Stack Developer</h3>
        </div>
    );
}

export default Main;
